<template>
  <div class="punch">
    <div class="searchRow">
      <el-input class="tableSearch" v-model="searchInfo" placeholder="考勤地点"></el-input>
      <!-- <el-date-picker class="tableSearch" v-model="searchMounth" type="month" placeholder="选择月"></el-date-picker>
      <el-select clearable class="tableSearch" v-model="searchClass" placeholder="请选择搜索部门">
        <el-option
          v-for="item in classList"
          :key="item.department_id"
          :label="item.department_name"
          :value="item.department_id"
        ></el-option>
      </el-select>
      <one-selected @my-one-change="handleSearchPeopleChange"></one-selected>-->
      <div class="btnCol">
        <el-button class="search" @click="handleSearch">查询</el-button>
        <el-button class="add" @click="handleAdd">新建</el-button>
        <!-- <el-button class="creat" style="background-color:#40A0F2;" @click="addUserClick">新建</el-button> -->
      </div>
    </div>
    <el-table
      :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
      :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
      :data="tableData"
      stripe
      height="calc(100% - 68px - 20px)"
      style="width: 100%; margin-top:20px"
    >
      <!-- 地点名字 -->
      <el-table-column prop="area_name" :show-overflow-tooltip="true" align="center" label="地点名字"></el-table-column>
      <!-- 经度 -->
      <el-table-column prop="lng" :show-overflow-tooltip="true" align="center" label="经度"></el-table-column>
      <!-- 纬度 -->
      <el-table-column prop="lat" :show-overflow-tooltip="true" align="center" label="纬度"></el-table-column>
      <!-- 打开距离 -->
      <el-table-column prop="distance" :show-overflow-tooltip="true" align="center" label="打开距离"></el-table-column>
      <!-- 添加时间 -->
      <el-table-column prop="add_time" :show-overflow-tooltip="true" align="center" label="添加时间"></el-table-column>
      <!-- 修改时间 -->
      <el-table-column prop="update_time" :show-overflow-tooltip="true" align="center" label="修改时间"></el-table-column>
      <!-- 操作 -->
      <el-table-column width="250" :show-overflow-tooltip="true" align="center" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleEdit(scope.row)" class="tableBtn">编辑</el-button>
          <el-button
            @click="handleRemove(scope.row)"
            class="tableBtn"
            style="border-color: #999999;color: #666666;"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="pageRow" v-if="tableData.length>0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        background
        :page-sizes="[5, 10, 15, 20, 30]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>-->
    <!-- 考勤地点新增 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      class="checkDia"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <!-- <span class="title-name" style="color:#128BF1;margin-right:5px">{{checkName}}</span> -->
        <span class="title-age">{{'考勤地点'}}</span>
      </div>
      <div class="mapContainer" style="width:100%; height:50vh">
        <div id="container" style="width:100%; height:100%"></div>
        <div class="selectOptions">
          <div id="pickerBox">
            <input id="pickerInput" placeholder="输入关键字选取地点" />
            <div id="poiInfo"></div>
          </div>
          <el-select @change="radiosChange" v-model="selectRadius" placeholder="请选择考勤范围">
            <el-option
              v-for="item in radiosList"
              :key="item.value"
              :label="item.lable"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="areaInfo" v-if="areaInfo.name">
          <p class="areaName">{{areaInfo.name}}</p>
          <p class="streetName">{{areaInfo.address}}</p>
        </div>
      </div>
      <div class="footerBtnRow" v-if="areaInfo.location">
        <el-button class="cancel" @click="handleNo">取消</el-button>
        <el-button class="yes" v-if="editId" @click="editSubmit">编辑</el-button>
        <el-button class="yes" v-if="!editId" @click="handleYes">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import OneSelected from '../../../components/OneSelected'

export default {
  data() {
    return {
      tiemID: null,
      timeDou: 100,
      checkName: '',
      searchInfo: '',
      searchUserId: '',
      searchClass: '',
      searchMounth: '',
      classList: [],
      tableData: [],
      tableData2: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      hasPoint: false,
      areaInfo: {
        address: '',
        location: '',
        name: '',
      },
      areaPoi: {},
      circle: {},
      dialogVisible: false,
      radiosList: [
        { lable: '考勤范围:50米', value: 50 },
        { lable: '考勤范围:100米', value: 100 },
        { lable: '考勤范围:200米', value: 200 },
        { lable: '考勤范围:300米', value: 300 },
        { lable: '考勤范围:400米', value: 400 },
        { lable: '考勤范围:500米', value: 500 },
        { lable: '考勤范围:600米', value: 600 },
        { lable: '考勤范围:700米', value: 700 },
        { lable: '考勤范围:800米', value: 800 },
        { lable: '考勤范围:900米', value: 900 },
        { lable: '考勤范围:1000米', value: 1000 },
        { lable: '考勤范围:1100米', value: 1100 },
        { lable: '考勤范围:1200米', value: 1200 },
        { lable: '考勤范围:1300米', value: 1300 },
        { lable: '考勤范围:1400米', value: 1400 },
        { lable: '考勤范围:1500米', value: 1500 },
        { lable: '考勤范围:2000米', value: 2000 },
      ],
      statusShow: '',
      map: {},
      selectRadius: 300,
      editId: '',
    }
  },
  components: {
    OneSelected,
  },
  methods: {
    handleSearch() {
      this.currentPage = 1
      this.getMounthList()
    },
    // !点击新增
    handleAdd() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.map = new AMap.Map('container', {
          zoom: 14,
        })
        this.map.on('click', this.clickHandler)
        AMapUI.loadUI(['misc/PoiPicker'], (PoiPicker) => {
          var poiPicker = new PoiPicker({
            input: 'pickerInput',
          })
          //初始化poiPicker
          this.poiPickerReady(poiPicker)
        })
      })
    },
    // *新增提交
    async handleYes() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)

        param.append('area_name', this.areaInfo.name)
        param.append('lng', this.areaInfo.location.split(',')[0])
        param.append('lat', this.areaInfo.location.split(',')[1])
        param.append('distance', this.selectRadius)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/ClockInSet/area_add',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)

        this.dialogVisible = false
        this.getMounthList()
      }, this.timeDou)
    },
    // *点击删除
    async handleRemove(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/ClockInSet/area_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getMounthList()
      }
    },
    // *编辑提交
    async editSubmit() {
      clearTimeout(this.tiemID)
      this.tiemID = setTimeout(async () => {
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('id', this.editId)

        param.append('area_name', this.areaInfo.name)
        param.append('lng', this.areaInfo.location.split(',')[0])
        param.append('lat', this.areaInfo.location.split(',')[1])
        param.append('distance', this.selectRadius)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/ClockInSet/area_edit',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)

        this.dialogVisible = false
        this.getMounthList()
      }, this.timeDou)
    },

    // !点击编辑
    async handleEdit(row) {
      this.areaInfo.location = row.lng + ',' + row.lat
      this.areaInfo.name = row.area_name
      this.selectRadius = parseInt(row.distance)
      this.editId = row.id

      this.dialogVisible = true
      this.$nextTick(() => {
        this.map = new AMap.Map('container', {
          zoom: 14,
        })
        this.map.on('click', this.clickHandler)
        AMapUI.loadUI(['misc/PoiPicker'], (PoiPicker) => {
          var poiPicker = new PoiPicker({
            input: 'pickerInput',
          })
          //初始化poiPicker
          this.poiPickerReady(poiPicker)
        })

        // 初始化地图上的点圈
        this.map.clearMap()
        const lnglatXY = [
          parseFloat(this.areaInfo.location.split(',')[0]),
          parseFloat(this.areaInfo.location.split(',')[1]),
        ]

        console.log('lnglatXY', lnglatXY)
        var marker = new AMap.Marker({
          position: new AMap.LngLat(lnglatXY[0], lnglatXY[1]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        })
        this.map.add(marker)

        this.circle = new AMap.Circle({
          // center: new AMap.LngLat('116.403322', '39.920255'), // 圆心位置
          center: marker.getPosition(), // 圆心位置
          radius: this.selectRadius, //半径
          strokeColor: '#479ff9', //线颜色
          strokeOpacity: 1, //线透明度
          strokeWeight: 3, //线粗细度
          fillColor: '#479ff9', //填充颜色
          fillOpacity: 0.35, //填充透明度
        })
        this.map.add(this.circle)

        // this.map.setCenter(new AMap.LngLat(lnglatXY[0], lnglatXY[1]))
        this.map.setCenter(marker.getPosition())
        this.map.setZoom(16)
        this.hasPoint = true
      })
    },
    // 新增点击取消
    handleNo() {
      this.areaInfo = {
        address: '',
        location: '',
        name: '',
      }
      this.dialogVisible = false
    },
    // !选择范围改变
    radiosChange() {
      // 清除覆盖物
      if (!this.hasPoint) return
      this.circle.setRadius(this.selectRadius)
      this.map.setFitView()
    },
    // !地图点击绑定事件
    clickHandler(e) {
      console.log('e', e)
      const lnglatXY = [e.lnglat.lng, e.lnglat.lat]
      console.log('lnglatXY', lnglatXY)
      // 根据坐标获取详细地址
      AMap.plugin('AMap.Geocoder', () => {
        var geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
          // city: '010',
        })
        geocoder.getAddress(lnglatXY, (status, result) => {
          if (status === 'complete' && result.info === 'OK') {
            // result为对应的地理位置详细信息
            console.log('result', result)
            this.areaInfo.address =
              result.regeocode.addressComponent.street +
              result.regeocode.addressComponent.streetNumber
            this.areaInfo.name = result.regeocode.formattedAddress
            this.areaInfo.location = lnglatXY.join(',')
            console.log('areaInfo', this.areaInfo)
          } else {
            this.$message.error('获取位置信息失败')
          }
        })
      })
      // 画圈画点
      this.map.clearMap()

      var marker = new AMap.Marker({
        position: new AMap.LngLat(lnglatXY[0], lnglatXY[1]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
      })
      this.map.add(marker)

      this.circle = new AMap.Circle({
        // center: new AMap.LngLat('116.403322', '39.920255'), // 圆心位置
        center: marker.getPosition(), // 圆心位置
        radius: this.selectRadius, //半径
        strokeColor: '#479ff9', //线颜色
        strokeOpacity: 1, //线透明度
        strokeWeight: 3, //线粗细度
        fillColor: '#479ff9', //填充颜色
        fillOpacity: 0.35, //填充透明度
      })
      this.map.add(this.circle)

      // this.map.setCenter(new AMap.LngLat(lnglatXY[0], lnglatXY[1]))
      this.map.setCenter(marker.getPosition())
      this.map.setZoom(16)
      this.hasPoint = true
    },

    // !搜索绑定事件
    poiPickerReady(poiPicker) {
      window.poiPicker = poiPicker

      var marker = new AMap.Marker()
      // var infoWindow = new AMap.InfoWindow({
      //   offset: new AMap.Pixel(0, -20),
      // })

      //选取了某个POI
      poiPicker.on('poiPicked', (poiResult) => {
        var source = poiResult.source,
          poi = poiResult.item,
          info = {
            source: source,
            id: poi.id,
            name: poi.name,
            location: poi.location.toString(),
            address: poi.address,
          }
        // this.areaInfo = info
        const infoAdress = info.address

        if (typeof infoAdress == 'string') {
          this.areaInfo.address = infoAdress
        } else {
          infoAdress.forEach((item) => {
            this.areaInfo.address += item
          })
        }
        this.areaInfo.name = info.name
        this.areaInfo.location = info.location
        this.areaPoi = poi
        console.log('info', info)
        console.log('poi', poi)
        this.map.clearMap()
        marker.setMap(this.map)
        // infoWindow.setMap(this.map)
        marker.setPosition(poi.location)

        this.circle = new AMap.Circle({
          // center: new AMap.LngLat('116.403322', '39.920255'), // 圆心位置
          center: marker.getPosition(), // 圆心位置
          radius: this.selectRadius, //半径
          strokeColor: '#479ff9', //线颜色
          strokeOpacity: 1, //线透明度
          strokeWeight: 3, //线粗细度
          fillColor: '#479ff9', //填充颜色
          fillOpacity: 0.35, //填充透明度
        })
        this.map.add(this.circle)
        // infoWindow.setPosition(poi.location)

        // infoWindow.setContent(
        //   'POI信息: <pre>' + JSON.stringify(info, null, 2) + '</pre>'
        // )
        // infoWindow.open(this.map, marker.getPosition())

        this.map.setCenter(marker.getPosition())
        this.map.setZoom(16)
        this.hasPoint = true
      })
    },
    // *获取考勤地点
    async getMounthList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)

      param.append('area_name', this.searchInfo)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/ClockInSet/area_list',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData = res.datas.data
      this.total = parseInt(res.datas.count)
      // this.isAdmin1 = res.datas.admin_state
      console.log('考勤地点', this.tableData)
    },
    // 获取部门列表
    async getClassList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      const { data: res } = await this.$axios({
        method: 'post',
        // url: '/api/Project/project_type',
        url: '/api/Project/is_business_department',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.classList = res.datas.listInfo
      console.log('项目类型列表', this.classList)
    },
    handleSearchPeopleChange(data) {
      console.log('组件传过来的搜索', data)
      this.searchUserId = data
    },
    handleSizeChange() {
      this.pageSize = val
      this.getMounthList()
    },
    handleCurrentChange() {
      this.currentUserPage = val
      this.currentPage()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.areaInfo = {
        address: '',
        location: '',
        name: '',
      }
      this.areaPoi = {}
      this.hasPoint = false
      this.editId = ''
    },
  },
  created() {
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.getClassList()
    this.getMounthList()
  },
}
</script>
<style lang="less" scoped>
.punch {
  height: 100%;
  // 搜索行
  .searchRow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .tableSearch {
      width: 20%;
      /deep/.el-input__inner {
        padding-left: 25px;
        height: 45px;
        border-radius: 24px;
        font-size: 16px;
        border: none;
        background-color: #f4f5f6;
        color: #333;
        &::placeholder {
          color: #333;
        }

        &::-webkit-input-placeholder {
          /* WebKit browsers 适配谷歌 */
          color: #333;
        }

        &:-moz-placeholder {
          /* Mozilla Firefox 4 to 18 适配火狐 */
          color: #333;
        }
      }
    }
    .btnCol {
      display: flex;
      align-items: center;
      /deep/.el-button {
        font-size: 18px;
        font-weight: normal;
        border: none;
        width: 130px;
        height: 45px;
        background: #f4a029;
        color: #fff;
        border-radius: 24px;
        padding: 0;
        margin-left: 30px;
      }
      .add {
        background: #0099ff;
      }
    }
  }
  /deep/.el-table__header {
    box-sizing: border-box;
    th {
      border-color: #40a0f2 !important;
    }
    .gutter {
      background-color: #40a0f2;
    }
  }
  // 分页行
  .pageRow {
    box-sizing: border-box;
    padding-top: 10px;
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    /deep/.el-pagination .el-select .el-input .el-input__inner {
      font-size: 14px;
    }
    /deep/.el-pagination button,
    /deep/.el-pagination span:not([class*='suffix']) {
      font-size: 14px;
    }
  }
  // 表格行
  /deep/.el-table__body {
    width: 100% !important;
  }
  .el-table::before {
    display: none;
  }
  /deep/.el-table__body-wrapper {
    box-sizing: border-box;
    border: 1px solid #f4f5f6;
  }
  // 鼠标经过效果
  /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #eff8ff;
  }
  // 斑马颜色
  /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
    background-color: #f4f5f6;
  }
  // 滚动条的宽度
  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    // position: absolute;
    // bottom: 0;
    width: 6px; // 横向滚动条
    height: 5px; // 纵向滚动条 必写
  }
  // 滚动条的滑块
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #ddd;
    border-radius: 3px;
  }
  // 滚动条的滑块
  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
    background-color: #ccc;
  }
  // *修改tabs样式
  /deep/.el-tabs__active-bar {
    width: 60px !important;
    margin-left: 30px;
  }
  /deep/.el-tabs {
    width: 100%;
    height: 100%;
    .el-tabs__header {
      width: 100%;
      margin-bottom: 20px;
      .el-tabs__nav-wrap {
        width: 100%;
        .el-tabs__nav-scroll {
          width: 100%;
          .el-tabs__nav {
            box-sizing: border-box;
            padding-left: 20px;
            width: 100%;
          }
        }
      }
    }
    .el-tabs__content {
      height: calc(100% - 80px);
      .el-tab-pane {
        height: 100%;
      }
    }
  }
  /deep/.el-tabs__item {
    height: 60px;
    text-align: center;
    font-size: 20px;
    color: #999999;
    font-weight: 400;
    padding-right: 100px;
    // width: 17%;
  }
  /deep/.el-tabs__item.is-active {
    color: #333 !important;
  }
  /deep/.el-tabs__item:hover {
    color: #333 !important;
  }
  /deep/.el-tabs__nav-wrap::after {
    color: #999999;
  }
  // 修改tabs样式

  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    padding-left: 30%;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    // (deep)
    .el-select {
      width: 100%;
      .el-input {
        width: 80%;
      }
      .el-input__inner {
        width: 100%;
        font-size: inherit;
      }
    }
    .el-input__inner {
      // font-size: 18px;
      font-size: inherit;
      width: 80%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 250px;
        // font-size: 18px;
        font-family: Microsoft YaHei;
        font-size: inherit;
        resize: none;
        border-radius: 0;
      }
    }
    .el-radio-group {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: 15%;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        // font-size: 18px;
        font-size: inherit;
      }
    }
  }
  .currentnumber {
    cursor: pointer;
  }
  .currentnumber:hover {
    color: #0099ff;
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  /deep/.heder40 {
    height: 56px;
  }
}
/deep/.ql-container {
  font-size: inherit;
}
.yauto {
  height: 40vh;
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
// 修改人员选择(搜索栏的人员选择)
/deep/#MyTransfer {
  width: 20%;
  .filter-dash-btn {
    border: none;
    border-radius: 24px;
    background-color: #f4f5f6;
    height: 45px;
    font-size: 16px;
  }
  .checked-app-item {
    margin-left: 10px;
    border: none;
    background-color: #f4f5f6;
  }
}
/deep/.checkDia {
  .el-dialog__body {
    width: 100%;
    box-sizing: border-box;
    padding: 30px 3%;
  }
  .footerBtnRow {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .cancel {
      background-color: #f4a029;
      height: 35px;
      display: flex;
      align-items: center;
      border: none;
      color: #fff;
    }
    .yes {
      background-color: #0099ff;
      border: none;
      height: 35px;
      display: flex;
      align-items: center;
      color: #fff;
    }
  }
}
// 高德地图
.mapContainer {
  position: relative;
  .selectOptions {
    position: absolute;
    width: 100%;
    display: flex;
    z-index: 9999;
    top: 20px;
    left: 30px;
    width: 300px;
    /deep/.el-select {
      margin-left: 30px;
      .el-input {
        .el-input__inner {
          width: 200px;
          height: 30px;
          font-weight: normal;
          color: #000;
          border-color: #767676;
          font-size: 12px !important;
          border-radius: 2px;
        }
        .el-input__icon {
          line-height: 30px;
        }
      }
    }
  }
  .areaInfo {
    box-sizing: border-box;
    border: 1px solid #767676;
    padding: 10px;
    position: absolute;
    top: 60px;
    left: 30px;
    background-color: #fff;
    .areaName {
      color: #333;
    }
    .streetName {
      font-size: 12px;
      color: #999;
    }
  }
}
#pickerInput {
  width: 200px;
  padding: 5px 5px;
}

#poiInfo {
  background: #fff;
}

.amap_lib_placeSearch .poibox.highlight {
  background-color: #cae1ff;
}

.amap_lib_placeSearch .poi-more {
  display: none !important;
}
/deep/#MyTransfer {
  .filter-dash-btn {
    width: 100%;

    .filter-tips-default {
      width: 100%;
      padding-left: 25px;
    }
  }
}
// 去掉日期选择器图标
/deep/ .el-input__prefix {
  .el-icon-date {
    display: none;
  }
}
</style>